import { render } from "./ModalRRIM.vue?vue&type=template&id=a6bd4462&scoped=true"
import script from "./ModalRRIM.vue?vue&type=script&lang=js"
export * from "./ModalRRIM.vue?vue&type=script&lang=js"

import "./ModalRRIM.vue?vue&type=style&index=0&id=a6bd4462&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bd4462"]])

export default __exports__